export const calculatePriceDelta = (skuPrice: number, panelItemPrice?: number) => {
	if (!panelItemPrice) return { delta: 0, color: 'gray' };

	const delta = skuPrice - panelItemPrice;
	const color = delta > 0 ? 'red' : 'green';
	return { delta, color };
};
